import React, { useState } from "react";
import { Icon, Tabs, Tooltip } from "antd";
import { StyledPlainButton } from "../../../styled-components/Button";
import { faArrowDown, faArrowUp } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  TI_WIDGET_CONTAINER_CLOSE_BUTTON,
  TI_WIDGET_CONTAINER_OPEN_BUTTON,
} from "../../../Constants";

const WidgetContainer = ({ children, onChange, tabIndex = 0 }) => {
  const [isFold, setIsFold] = useState(false);

  const tabProps = {
    // activeTabIndex, visible, setTitleWithIndex,
  };

  return (
    <>
      {children && (
        <div style={WIDGET_CONTAINER_STYLE} className={"widget-container-r"}>
          <div
            style={FOLD_BUTTON_WRAPPER_STYLE}
            onClick={() => setIsFold((checked) => !checked)}
          >
            <div style={FOLD_SPACE_STYLE} />
            <div style={FOLD_BUTTON_STYLE} className={"background-arrow-r"}>
              {isFold && (
                <button
                  aria-label="펼치기"
                  style={{
                    border: "0px",
                    backgroundColor: "#fff",
                  }}
                  tabIndex={TI_WIDGET_CONTAINER_OPEN_BUTTON}
                >
                  <Tooltip title={"펼치기"}>
                    <FontAwesomeIcon icon={faArrowDown} />
                    {/* <Icon type="arrow-down" /> */}
                  </Tooltip>
                </button>
              )}
              {!isFold && (
                // <StyledPlainButton>
                <Tooltip title={"접기"}>
                  <button
                    aria-label="접기"
                    style={{
                      border: "0px",
                      backgroundColor: "#fff",
                    }}
                    tabIndex={TI_WIDGET_CONTAINER_CLOSE_BUTTON}
                  >
                    <FontAwesomeIcon icon={faArrowUp} />
                    {/* <Icon type="arrow-down" /> */}
                    {/* <Icon type="arrow-up" /> */}
                  </button>
                </Tooltip>
                // </StyledPlainButton>
              )}
            </div>
          </div>

          <div style={WIDGET_STYLE} className={"widget-search-r"}>
            {isFold && (
              <div style={{ textAlign: "center" }}>검색조건 펼치기</div>
            )}
            <div hidden={isFold}>
              {!Array.isArray(children) && children}
              {Array.isArray(children) && (
                <Tabs type={"card"} animated={false} onChange={onChange}>
                  {children.map((child, tabIndex) => {
                    const {
                      props: { title },
                    } = child;
                    return (
                      <Tabs.TabPane
                        tab={title || `Tab #${tabIndex}`}
                        key={title}
                      >
                        {React.cloneElement(child, { tabIndex, ...tabProps })}
                      </Tabs.TabPane>
                    );
                  })}
                </Tabs>
              )}
            </div>
          </div>
        </div>
      )}
    </>
  );
};

const WIDGET_CONTAINER_STYLE = {
  position: "absolute",
  left: 28,
  top: 48,
  width: 350,
  zIndex: 1,
};

const WIDGET_STYLE = {
  background: "white",
  padding: 10,
  boxShadow: "2px 2px 5px 0px rgba(0, 0, 0, 0.5)",
  borderRadius: 6,
};

const FOLD_BUTTON_WRAPPER_STYLE = {
  position: "absolute",
  bottom: "-23px",
  left: "calc(50% - 40px)",
  textAlign: "center",
  width: "80px",
  height: "24px",
  cursor: "pointer",
};

const FOLD_SPACE_STYLE = {
  backgroundColor: "white",
  width: "100%",
  height: 4,
  position: "absolute",
  top: 0,
  marginTop: "-4px",
};

const FOLD_BUTTON_STYLE = {
  padding: "1px",
  background: "white",
  borderRadius: "0 0 6px 6px",
  boxShadow: "2px 2px 5px 0px rgba(0, 0, 0, 0.5)",
};

export default WidgetContainer;
